<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Articles"
                createIconText="Ajouter un article"
                importDatasourceName="articles"
                (created)="onArticleCreated()"
                (exported)="onArticleExported()"
                (imported)="onArticleImported()"
                (helped)="onArticleHelped()"></app-list-header>
        </mat-expansion-panel-header>
        <app-articles-list
            #itemsList
            (itemSelected)="onArticleSelected($event)"
            (itemDisplayed)="onArticleDisplayed($event)"
            (itemEdited)="onArticleEdited($event)"
            (itemDeleted)="onArticleDeleted($event)"
            (itemDuplicated)="onArticleDuplicated($event)">
            (itemsSorted)="onAttributesSorted($event)">>
        </app-articles-list>
    </mat-expansion-panel>

    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onArticleDisplayed(context?.formContext.item)"
                    (edited)="onArticleEdited(context?.formContext.item)"
                    (helped)="onArticleHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-article-detail [context]="context" (articleUpdated)="onArticleUpdated($event)" (canceled)="onBackToList()"></app-article-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
